/* avatar-slot.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./avatar-slot.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Box } from '@atlaskit/primitives/compiled';
var avatarSectionStyles = {
  root: "_nd5l1ofd"
};
/**
 * __Avatar slot is used to nest an avatar in a comment__
 *
 * The avatar slot is used to nest an avatar in a comment's layout.
 *
 */
var AvatarSlot = function AvatarSlot(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: avatarSectionStyles.root
  }, children);
};
export default AvatarSlot;